import { render } from "./WordsView.vue?vue&type=template&id=b1c2227e&scoped=true"
import script from "./WordsView.vue?vue&type=script&lang=js"
export * from "./WordsView.vue?vue&type=script&lang=js"

import "./WordsView.vue?vue&type=style&index=0&id=b1c2227e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c2227e"]])

export default __exports__